import React from 'react';
// import { FaMap, FaDownload } from 'react-icons/fa';
// import { BiHealth } from 'react-icons/bi';
// import { GiRiver } from 'react-icons/gi';
// import { MdSchool } from 'react-icons/md';
// import { useHistory } from 'react-router-dom';
// import Card from '~/Components/Card';
import { Content, Header/* , CardsContainer */ } from './styles';
// import { COLORS } from '~/styles/colors';
import Footer from '~/Components/Footer';

function Info() {
	return (
		<>
			<Content>
				<Header>INFORMAÇÃO BÁSICA POR ZONEMAMENTO</Header>
				<p>
					Metadados são informações de determinado dado. Os metadados
					são essenciais para organização e classificação de conjuntos
					de dados. Contemplam informações como: título, nome do
					arquivo, tipo de arquivo, geometria, escala de vetorização,
					Datum, Fuso UTM
				</p>
				{/* <p style={{ color: 'red' }}>
					<b>Seção temporariamente indisponível</b>
				</p> */}
			</Content>
			<Footer />
		</>
	);
}

export default Info;